export const enum UserRegistrationViewStoreEvent {
  clickLogin = 'click-login',
  clickClose = 'click-close',
}
